import { render, staticRenderFns } from "./PremiumTable.vue?vue&type=template&id=11d7edcb&scoped=true"
import script from "./PremiumTable.vue?vue&type=script&lang=js"
export * from "./PremiumTable.vue?vue&type=script&lang=js"
import style0 from "./PremiumTable.vue?vue&type=style&index=0&id=11d7edcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d7edcb",
  null
  
)

export default component.exports